import { useCallback, useContext, useEffect, useRef, useState, useSyncExternalStore } from "react";
import { queryFeatureSet, tableFeatureService } from "../../../services/arcGisService/arcGisService";
import { ObjectState, ProcessMarker } from "./types/tasklListViewProps";
import { apiContext } from "../../../contexts/apiContext";
import Tabbar from "../../../components/shared/tabbar/tabbar";
import { TabbarOption } from "../../../components/shared/tabbar/types/tabbarProps";
import ViewTaskListContext from "../../../contexts/viewTaskListContext";
import TaskListLocalTabView from "./taskListLocalTabView/taskListLocalTabView";
import TaskListWaitingTabView from "./taskListWaitingTabView/taskListWaitingTabView";
import { ReactComponent as hourglass } from "../../../icons/hourglass_top.svg";
import { ReactComponent as computer } from "../../../icons/computer.svg";
import './taskListView.scss';
import { deleteTask, getDictionaries, getTableAliases, getTableSettings, getTask, getTaskListFromDb, setCodedValuesDictionaries, setDicts, setTableAliases, setTableSettings, setTaskListInDb, setTaskStatus } from "../../../database/indexedDbReadWrite";
import { HeadersTable } from "../../../helpers/featureTableConstruct";
import Query from "@arcgis/core/rest/support/Query.js";
import { buildWhereFromMapToKr, fromTableToMap, getObjKey } from "../../../helpers/map/query";
import { mapStore } from "../../../stores/mapStore";
import AuthContext from "../../../contexts/authContext";
import { showFeatures } from "../../../helpers/map/map";
import { FiltersTable, SortType, TableContext } from "../../../contexts/tableContext";
import ViewContext from "../../../contexts/viewContext";
import { TaskListWaitingTabViewProps } from "./taskListWaitingTabView/types/taskListWaitingTabViewProps";
import { TaskListLocalTabViewProps } from "./taskListLocalTabView/types/taskListLocalTabViewProps";
import { notifyError, notifySuccess, notifyWarn } from "../../../components/snackbar/snackbar";
import { updateProtocolState, validateSelectedProtocols } from "../../../services/protocolFormService/protocolFormService";
import { UpdateProtocolStateProps, ValidateSelectedProtocolsProps } from "../../../services/protocolFormService/types/protocolFormServiceProps";
import { ColumnConfig, ColumnType, ThreeDotsTableTypes } from "../../../components/shared/table/types/tableProps";
import { changeStatusRegistrationCardForm, changeStatusRegistrationCardFormForCollectiveEdit, changeStatusRegistrationCardFormForDownload, checkEditorCards, getCardsForValidation, returnCards, validateSelectedCards, getMiejscowosciGids, getCardsForDownloading, krToSave } from "../../../services/registrationCardService/registrationCardService";
import { CardDownloadMode, CardReturn, CardStateUpdate, Cards, CardsDownloadProps, CardsValidationProps, CheckEditor, ObjectsReturn, ValidateSelectedCardsProps } from "../../../services/registrationCardService/types/registrationCardServiceProps";
import { ObjectType } from "../../../contexts/types/card";
import CancelTaskWindow from "./taskListWaitingTabView/cancelTaskWindow";
import { CancelTaskType } from "../../../services/mainDatabaseService/types/mainDatabaseServiceProps";
import AssignEditorVerifierModal from "../shared/assignEditorVerifierModal/assignEditorVerifierModal";
import PermissionsContext from "../../../contexts/permissionsContext";
import { AssignEditorVerifierModalProps } from "../shared/assignEditorVerifierModal/types/assignEditorVerifierModalProps";
import { canAssignEditor, canAssignVerifier, canHaveEditorAssignedByVerifier, getObjectTypeCodedValue } from "../../../helpers/processHelper";
import Modal from "../../../components/modalWindow/modal";
import { ReactComponent as personAdd } from '../../../icons/person_add.svg';
import { ButtonFieldProps } from "../../../components/buttonField/types/buttonFieldProps";
import { stylizationVerticalAlign } from "../../../components/shared/stylization";
import ButtonField from "../../../components/buttonField/buttonField";
import AutomaticVerificationModal from "./modals/automaticVerificationModal/automaticVerificationModal";
import { PrepareValidations } from "./modals/automaticVerificationModal/automaticVerificationHelper";
import { AutomaticVerificationModalProps } from "./modals/automaticVerificationModal/types/automaticVerificationModalProps";
import { Dictionary, getAdditionalDictionaries, getDictionariesForValidation, getDictionariesFromLayers, getDictionaryForCodedValues } from "../../../helpers/dictionariesFromLayers";
import { KrEndangeredAreaFormTypes, KrLandslideFormTypes } from "../../../contexts/krFormContext";
import { poFormTypes } from "../../../contexts/poFormContext";
import { ElementParams } from "../../../database/indexedDbConfig";
import { PaginationState } from "@tanstack/react-table";
import { filterLocal, filtersToQuery } from "../../../helpers/filter";
import { setDevelopmentsRelTech } from "../../../helpers/form";

//Shared table pagination for local and online table
const DATABASE_TABLE = 'TLT';

const TaskListView = () => {
    const api = useContext(apiContext);
    const { user, username, userRoles, onlineMode } = useContext(AuthContext);
    const { setViewTaskListType, viewTaskListTypes, viewTaskListType } = useContext(ViewTaskListContext);
    const { setViewType, setViewData, viewTypes } = useContext(ViewContext);
    const { filtersTableTaskList, checkboxesTable, setCheckboxesTable, reloadTable, setReloadTable, sortConfigTaskList } = useContext(TableContext);
    const [headersExtend, setHeadersExtend] = useState<HeadersTable>({});
    const [featureSetExtend, setFeatureSetExtend] = useState<__esri.Graphic[] | any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const customMap = useSyncExternalStore(mapStore.subscribe, mapStore.getSnapshot);
    const [mapSelection, setMapSelection] = useState<__esri.Graphic[]>([]);
    const [selected, setSelected] = useState<__esri.Graphic[]>([]);
    const [cancelType, setCancelType] = useState<CancelTaskType | null>(null);
    const [showEditorVerifierModal, setShowEditorVerifierModal] = useState<boolean>(false);
    const [confirmationEditorVerifier, setConfirmationEditorVerifier] = useState<boolean>(false);
    const [automaticVerificationModal, setAutomaticVerificationModal] = useState<boolean>(false);
    const [rowsForModal, setRowsForModal] = useState<any[]>([])
    const [isModalEditorVersion, setIsModalEditorVersion] = useState<any>()
    const [assignEditorByVerifier, setAssignEditorByVerifier] = useState<boolean>(false)
    const { functionsPermissions, extendedUserPermissions } = useContext(PermissionsContext);
    const [automaticVerificationCards, setAutomaticVerificationCards] = useState<Cards | null>(null);
    const [pagination, setPagination] = useState<PaginationState>({ pageIndex: 0, pageSize: 0 });
    const [pageCount, setPageCount] = useState<number>(1);
    const [allCount, setAllCount] = useState<number>(0);
    const [adminDecisionRow, setAdminDecisionRow] = useState<any | undefined>(undefined)

    const tableSelection = useRef<{ [id: string]: __esri.Graphic | null }>({});
    const columnConfig = useRef<ColumnConfig[]>([{ name: "DATA_OBS", type: ColumnType.Date }]);

    const getSelectedTab = () => {
        var isWaitingRoomTab = functionsPermissions.browseUserKRPOWaitingTab.active || functionsPermissions.browseAllKRPOWaitingTab.active;
        var isLocalTab = functionsPermissions.browseKRPOInLocalBase.active;

        if (!onlineMode || (!isWaitingRoomTab && isLocalTab)) {
            return viewTaskListTypes.TaskListLocal;
        } else if (isWaitingRoomTab) {
            return isLocalTab ? viewTaskListType : viewTaskListTypes.TaskListWaiting;
        }
        return viewTaskListTypes.TaskListWaiting;
    }

    const [selectedTab, setSelectedTab] = useState<number>(getSelectedTab());

    useEffect(() => {
        if (pagination.pageSize === 0) {
            getTableSettings(username, DATABASE_TABLE).then((tSettings) => {
                setPagination({ pageIndex: 0, pageSize: tSettings.pageSize });
            }, () => {
                setPagination({ pageIndex: 0, pageSize: 10 })
            });
        }
    }, [username, pagination.pageSize])

    const recalcPagination = useCallback((all: number) => {
        const newPageCount = all !== undefined ? Math.ceil(all / pagination.pageSize) : 1;
        if (newPageCount < pagination.pageIndex + 1) {
            const newPageIndex = newPageCount - 1 >= 0 ? newPageCount - 1 : 0;
            setPagination({ pageSize: pagination.pageSize, pageIndex: newPageIndex });
        }
        setPageCount(newPageCount);
        setAllCount(all);
    }, [pagination.pageIndex, pagination.pageSize])

    const onPaginationChange = (name: string, value: any) => {
        if (name === 'pageSize') {
            setTableSettings(username, { name: DATABASE_TABLE, pageSize: value });
        }
    }

    const onClickOption = (navigate: number, event: React.SyntheticEvent<HTMLLIElement>) => {
        event.currentTarget.className = "activeTab";
        setViewTaskListType(navigate);
        setSelectedTab(navigate);
    }

    useEffect(() => {
        if (onlineMode === false && viewTaskListType === viewTaskListTypes.TaskListWaiting) {
            setViewTaskListType(viewTaskListTypes.TaskListLocal);
            setSelectedTab(viewTaskListTypes.TaskListLocal);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onlineMode, setViewTaskListType, viewTaskListType, viewTaskListTypes.TaskListLocal, viewTaskListTypes.TaskListWaiting])

    const getUserWhere = useCallback(() => {
        return `PRZYPISANY_UZYTKOWNIK='${username}' AND ${whereBuild(filtersTableTaskList)}`;
    }, [username, filtersTableTaskList])

    const handleTrClick = (featuresWaiting: __esri.Graphic[] | any[]) => {
        setMapSelection([]);
        let features = featuresWaiting;
        if (selectedTab === viewTaskListTypes.TaskListLocal) {
            features = features.map((feature) => {
                let newFeature: any = {
                    attributes: feature
                }
                return newFeature;
            })
        }
        setSelected(features);
        const view = mapStore.getView();
        if (view) {
            const tableToMap = fromTableToMap(tableSelection.current, features);
            if (tableToMap.newRec !== null) {
                var objectType = tableToMap.newRec.attributes.RODZAJ_OBIEKTU;
                var idNumber = tableToMap.newRec.attributes.NUMER_IDENTYFIKACYJNY;
                const fKey = getObjKey(objectType, idNumber);
                if (!tableToMap.newRec.attributes.SHAPE_YES_NO) {
                    tableToMap.ts[fKey] = null;
                    tableSelection.current = tableToMap.ts;
                    const toShowFeatures = filterShowFeatures(tableToMap.ts);
                    showFeatures(view, toShowFeatures);
                    return;
                }
                setLoading(true);
                const query = new Query({
                    outFields: ["NUMER_IDENTYFIKACYJNY"],
                    returnGeometry: true,
                    where: `RODZAJ_OBIEKTU='${objectType}' AND NUMER_IDENTYFIKACYJNY=${idNumber}`
                })
                let _query = queryFeatureSet({ url: api.featureServices.taskList }, query);
                _query.promise.then((featureSet: any) => {
                    if (featureSet.data !== null && featureSet.data.length > 0) {
                        tableToMap.ts[fKey] = featureSet.data[0];
                        tableSelection.current = tableToMap.ts;
                    } else {
                        tableToMap.ts[fKey] = null;
                        tableSelection.current = tableToMap.ts;
                    }
                    const toShowFeatures = filterShowFeatures(tableToMap.ts);
                    showFeatures(view, toShowFeatures);
                    setLoading(false);
                }).catch((err: any) => {
                    console.error('Unable get geometry');
                    const toShowFeatures = filterShowFeatures(tableToMap.ts);
                    showFeatures(view, toShowFeatures);
                    setLoading(false);
                })
            } else {
                tableSelection.current = tableToMap.ts;
                const toShowFeatures = filterShowFeatures(tableToMap.ts);
                showFeatures(view, toShowFeatures);
            }
        }
    }

    const filterShowFeatures = (ts: { [id: string]: __esri.Graphic | null }) => {
        return Object.values(ts).filter(v => v !== null) as __esri.Graphic[];
    }

    const handleThreeDotsValidateClick = () => {
        if (checkboxesTable.length === 1) {
            let row = checkboxesTable[0].original;
            if (!row.attributes) {
                row.attributes = row;
            }
            const objectState = row.attributes?.STAN_OBIEKTU_DOM;
            let objectType = row.attributes.RODZAJ_OBIEKTU;
            var isKR = objectType === ObjectType.KRO || objectType === ObjectType.KRTZ;
            if (isKR && selectedTab === viewTaskListTypes.TaskListLocal && objectState === ObjectState.DownloadedForVerification) {
                setViewData({ row: row, editMode: false, local: true });
                setViewType(viewTypes.KRForm);
            }
            else if (isKR && selectedTab === viewTaskListTypes.TaskListWaiting && objectState !== ObjectState.DownloadedForVerification) {
                setViewData({ row: row, editMode: false, local: false });
                setViewType(viewTypes.KRForm);
            }
        }
    }

    const handleThreeDotsEditClick = () => {
        if (checkboxesTable.length === 1) {
            var row = checkboxesTable[0].original;
            if (!row.attributes) {
                row = {
                    attributes: row
                }
            }

            const objectType = row.attributes.RODZAJ_OBIEKTU;
            const isLocal = selectedTab === viewTaskListTypes.TaskListLocal;

            if (objectType === ObjectType.KRO || objectType === ObjectType.KRTZ) {
                setViewData({ row: row, editMode: true, local: isLocal });
                setViewType(viewTypes.KRForm);
            } else if (objectType === ObjectType.POO || objectType === ObjectType.POTZ) {
                setViewData({ row: row, local: isLocal });
                setViewType(viewTypes.POForm);
            }
        }
    }

    const handleThreeDotsCollectiveEditClick = () => {
        if (selectedTab === viewTaskListTypes.TaskListLocal) {
            let rows = checkboxesTable.map(checkbox => {
                if (!checkbox.original.attributes) {
                    let checkboxx = {
                        attributes: checkbox.original
                    }
                    return checkboxx;
                }
                else {
                    return checkbox.original
                }
            });
            setViewData(rows);
            const toStatusChangeGids = rows
                .filter(row => row.attributes.STAN_OBIEKTU_DOM === ObjectState.Assigned)
                .map(row => row.attributes.GLOBALID);
            if (toStatusChangeGids.length > 0) {
                setLoading(true);
                const PromiseArray: Promise<any>[] = [];
                for (let i = 0; i < toStatusChangeGids.length; i++) {
                    PromiseArray.push(setTaskStatus(toStatusChangeGids[i], ObjectState.WaitingRoomEdition))
                }
                if (PromiseArray.length > 0) {
                    return Promise.all(PromiseArray).then(() => {
                        setLoading(false);
                        setViewType(viewTypes.CollectiveEditFormLocal);
                    }).catch((error) => {
                        console.log("error changing status", error);
                        changeStatusFailed();
                    })
                }
            }
            else {
                setViewType(viewTypes.CollectiveEditFormLocal);
            }
        }
        else {
            let rows = checkboxesTable.map(checkbox => checkbox.original);
            setViewData(rows);
            const toStatusChangeGids = checkboxesTable
                .filter(row => row.original.attributes.STAN_OBIEKTU_DOM === ObjectState.Assigned)
                .map(row => row.original.attributes.GLOBALID);
            if (toStatusChangeGids.length > 0) {
                setLoading(true);
                changeStatusForCollectiveEdit(ObjectState.WaitingRoomEdition, toStatusChangeGids)
                    .then((res: any) => {
                        setLoading(false);
                        if (res.success) {
                            setViewType(viewTypes.CollectiveEditForm);
                        } else if (res.info) {
                            notifyError({ message: `Niepowodzenie: '${res.info}'` });
                        } else {
                            changeStatusFailed();
                        }
                    }).catch(() => { changeStatusFailed(); })
            } else {
                setViewType(viewTypes.CollectiveEditForm);
            }
        }
    }

    const handleThreeDotsCancelOAndKClick = () => {
        if (checkboxesTable.length >= 1) {
            setCancelType(CancelTaskType.OK);
        }
    }

    const handleThreeDotsCancelAAndNClick = () => {
        if (checkboxesTable.length >= 1) {
            setCancelType(CancelTaskType.AN);
        }
    }

    useEffect(() => {
        if (adminDecisionRow !== undefined) {
            [ProcessMarker.O, ProcessMarker.K].includes(adminDecisionRow.original.attributes.ZNACZNIK_PROCESU_DOM) ? setCancelType(CancelTaskType.OK) : setCancelType(CancelTaskType.AN);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [adminDecisionRow]);

    const setCancelClose = (cancel: boolean) => {
        setCancelType(null);
        if (adminDecisionRow !== undefined) setAdminDecisionRow(undefined);
        if (cancel === false) {
            setCheckboxesTable([]);
        }
    }

    const changeStatus = (status: string, gids: string[], isEditor: boolean) => {
        return changeStatusRegistrationCardForm(status, gids, api.apiUrl + api.apiVersion, isEditor);
    }

    const changeStatusForCollectiveEdit = (status: string, gids: string[]) => {
        return changeStatusRegistrationCardFormForCollectiveEdit(status, gids, api.apiUrl + api.apiVersion);
    }

    const handleThreeDotsAssignEditorClick = (actionByVerifier: boolean) => {
        if (checkboxesTable.length > 0) {
            var checkedRows = checkboxesTable.map(item => {
                item.original.attributes.RODZAJ_OBIEKTU_DOM = getObjectTypeCodedValue(item.original.attributes.RODZAJ_OBIEKTU);
                return item.original.attributes
            });
            setRowsForModal(checkedRows);
            setAssignEditorByVerifier(actionByVerifier);
            setShowEditorVerifierModal(true);
            setIsModalEditorVersion(true);
        }
    }

    const handleThreeDotsAutomaticVerificationClick = async () => {
        var checkedRows = checkboxesTable.map(item => {
            if (!item.original.attributes) return item.original.ID;
            return item.original.attributes.ID;
        })
        if (selectedTab === viewTaskListTypes.TaskListLocal) {
            checkedRows = checkboxesTable.map(item => {
                if (!item.original.attributes) return item.original.GLOBALID;
                return item.original.attributes.GLOBALID;
            })
        }
        setLoading(true);
        getCardsForAutomaticVerification(checkedRows);
    }

    const getCardsForAutomaticVerification = async (checkedRows: any[]) => {
        if (selectedTab === viewTaskListTypes.TaskListLocal) {
            const PromiseArray: Promise<any>[] = [];
            for (let i = 0; i < checkedRows.length; i++) {
                PromiseArray.push(getTask(checkedRows[i] as string));
            }
            if (PromiseArray.length > 0) {
                return Promise.all(PromiseArray).then((response) => {
                    var properties: AutomaticVerificationModalProps = {
                        cards: {
                            populateLandslideCardResponse: [],
                            populateEndangeredAreaCardResponse: [],
                            populateProtocolFormResponse: []
                        }
                    }
                    response.forEach((resp) => {
                        if (resp.elementParams.card.landslideAttributes) {
                            let form = resp.elementParams.card as KrLandslideFormTypes;
                            properties.cards?.populateLandslideCardResponse.push(form);
                        }
                        if (resp.elementParams.card.endangeredAreaAttributes) {
                            let form = resp.elementParams.card as KrEndangeredAreaFormTypes;
                            properties.cards?.populateEndangeredAreaCardResponse.push(form);
                        }
                        if (resp.elementParams.card.protocolAttributes) {
                            let form = resp.elementParams.card as poFormTypes;
                            properties.cards?.populateProtocolFormResponse.push(form);
                        }
                    })
                    let configKey: string | null = null;
                    if (properties.cards ? properties.cards.populateLandslideCardResponse.length > 0 : false) {
                        configKey = 'landslide';
                    } else if (properties.cards ? properties.cards.populateEndangeredAreaCardResponse.length > 0 : false) {
                        configKey = 'endangeredArea';
                    }
                    if (configKey !== null) {
                        getDictionaries(configKey).then((dicts) => {
                            if (properties.cards) { properties.cards.dictionariesForValidation = dicts; }
                            setAutomaticVerificationCards(properties.cards as Cards);
                            PrepareValidations(properties, [], api, true, dicts);
                        }).finally(() => {
                            setAutomaticVerificationModal(true);
                            setLoading(false);
                        })
                    } else {
                        setAutomaticVerificationCards(properties.cards as Cards);
                        PrepareValidations(properties, [], api, true);

                        setAutomaticVerificationModal(true);
                        setLoading(false);
                    }
                }).catch(() => {
                    setAutomaticVerificationModal(true);
                    setLoading(false);
                });
            }
        }
        else {
            let cardsForValidationProps: CardsValidationProps = {
                waitingRoomIds: checkedRows,
                apiBase: api.apiUrl + api.apiVersion
            }
            getCardsForValidation(cardsForValidationProps).then((response: any) => {
                let DictionariesLandslide: Dictionary = {};
                let cardResponse = response as Cards;
                let gids: string[] = getMiejscowosciGids(cardResponse);
                let miejscowosciGminyWhere = gids.length > 0 ? `GLOBALID IN(${gids.map(g => `'${g}'`).join(",")})` : undefined;
                getDictionariesForValidation(api.featureServices.additionalDictionariesBaseUrl, api.featureServices.additionalDictionaries["landslide"], DictionariesLandslide, miejscowosciGminyWhere).then(() => {
                    cardResponse.dictionariesForValidation = DictionariesLandslide;
                    setAutomaticVerificationCards(cardResponse);
                    var properties: AutomaticVerificationModalProps = {
                        cards: cardResponse
                    }
                    PrepareValidations(properties, [], api, undefined, DictionariesLandslide)?.then(() => {
                        notifySuccess({ message: "Statusy walidacji kart zostały zaktualizowane" });
                        setAutomaticVerificationModal(true);
                    }).catch(() => {
                        notifyError({ message: "Błąd podczas aktualizacji statusu" });
                    }).finally(() => {
                        setLoading(false);
                    });
                }).catch(() => {
                    setLoading(false);
                })
            }).catch(() => {
                notifyError({ message: "Próba walidacji formularzy zakończona niepowodzeniem" });
                setLoading(false);
            });
        }
    }

    const handleThreeDotsDownloadCardClick = (downloadMode: CardDownloadMode) => {
        var checkedRows = checkboxesTable.map(item => {
            return item.original.attributes;
        })
        setLoading(true);
        getCardsForDownloadingCard(checkedRows, downloadMode);
    }

    const checkStatuses = () => {
        var statusAvailable = true;
        checkboxesTable.forEach((item) => {
            const objectStatus = item.original.attributes.STAN_OBIEKTU_DOM

            // Check cards downloaded for edit
            if (!functionsPermissions?.downloadKRPOToEdit.active && (objectStatus === ObjectState.Assigned || objectStatus === ObjectState.ToBeCorrected
                || objectStatus === ObjectState.WaitingRoomEdition)) {
                notifyWarn({ message: "Nie można pobrać karty " + item.original.attributes.NUMER_IDENTYFIKACYJNY + " o statusie " + objectStatus });
                statusAvailable = false;
            }

            // Check cards downloaded for verification
            if (!functionsPermissions?.downloadKRForVerification.active && (objectStatus === ObjectState.ToBeVerified || objectStatus === ObjectState.WaitingRoomEditionVerification)) {
                notifyWarn({ message: "Nie można pobrać karty " + item.original.attributes.NUMER_IDENTYFIKACYJNY + " o statusie " + objectStatus })
                statusAvailable = false;
            }

            // Check for cards already downloaded
            if (objectStatus === ObjectState.DownloadedForEdition || objectStatus === ObjectState.DownloadedForVerification) {
                notifyWarn({ message: "Nie można pobrać karty " + item.original.attributes.NUMER_IDENTYFIKACYJNY + " o statusie " + objectStatus });
                statusAvailable = false;
            }
        });
        return statusAvailable;
    }

    const checkIfOnCopmuter = (elements: (KrLandslideFormTypes | KrEndangeredAreaFormTypes | poFormTypes)[]) => {
        const PromiseArray: Promise<any>[] = [];
        for (let i = 0; i < elements.length; i++) {
            PromiseArray.push(getTask(elements[i].waitingRoomGlobalId!));
        }
        if (PromiseArray.length > 0) {
            return Promise.all(PromiseArray).then((response) => {
                let responseFiltered = response.filter((element) => {
                    return element !== undefined;
                })
                if (responseFiltered.length > 0) {
                    notifyWarn({ message: "Jedna z wybranych kart istnieje już w bazie lokalnej" });
                    return true;
                }
                else {
                    return false;
                }
            }).catch((error) => {
                console.log("ERROR when getting task error: " + error);
                notifyError({ message: "Błąd podczas pobierania karty do sprawdzenia: " + error });
                return false;
            })
        }
        else {
            return undefined;
        }
    }

    const getConcatCards = (cards: Cards[]) => {
        var allCards: Cards = {
            populateEndangeredAreaCardResponse: cards[0].populateEndangeredAreaCardResponse.concat(cards[1].populateEndangeredAreaCardResponse),
            populateLandslideCardResponse: cards[0].populateLandslideCardResponse.concat(cards[1].populateLandslideCardResponse),
            populateProtocolFormResponse: cards[0].populateProtocolFormResponse.concat(cards[1].populateProtocolFormResponse)
        }
        return allCards;
    }

    const getCardsForDownloadingCard = async (checkedRows: any[], downloadMode: CardDownloadMode) => {
        let cardsForDownloadProps: CardsDownloadProps = {
            downloadMode: downloadMode,
            waitingRoomRecs: checkedRows,
            apiBase: api.apiUrl + api.apiVersion
        }

        getCardsForDownloading(cardsForDownloadProps).then((response: any) => {
            var Dictionaries: Dictionary = {};
            var cards = response.length > 1 ? getConcatCards(response) : response as Cards;
            if (cards) {
                cards.populateLandslideCardResponse.forEach(c => {
                    setDevelopmentsRelTech(c);
                });
                if (checkStatuses()) {
                    getAdditionalDictionaries(api.featureServices.additionalDictionariesBaseUrl, api.featureServices.additionalDictionaries["endangeredArea"], Dictionaries, true, undefined, true).then(() => {
                        setDicts(Dictionaries, "endangeredArea");
                        let DictionariesLandslide: Dictionary = {};
                        getAdditionalDictionaries(api.featureServices.additionalDictionariesBaseUrl, api.featureServices.additionalDictionaries["landslide"], DictionariesLandslide, true, undefined, true).then(() => {
                            var elementsNew: ElementParams[] = [];
                            var elements: (KrLandslideFormTypes | KrEndangeredAreaFormTypes | poFormTypes)[] = [];
                            elements = elements.concat(cards.populateEndangeredAreaCardResponse);
                            elements = elements.concat(cards.populateLandslideCardResponse);
                            elements = elements.concat(cards.populateProtocolFormResponse);
                            setDicts(DictionariesLandslide, "landslide");

                            var authorDictId = api.featureServices.dictionariesForCodedValues.find(item => item[0] === "AUTORZY");
                            if (authorDictId) {
                                getDictionaryForCodedValues(api.featureServices.dictionariesForEditingBaseUrl + authorDictId[1])
                                .then((res) => {
                                    var dictId: number = +authorDictId![1];
                                    var codedVals = getDictionariesFromLayers(res, [dictId]);
                                    setCodedValuesDictionaries(codedVals);

                                    checkIfOnCopmuter(elements)?.then((response) => {
                                        if (!response) {
                                            for (let i = 0; i < elements.length; i++) {
                                                let foundedElement = checkboxesTable.find((row) => {
                                                    return row.original.attributes.GLOBALID === elements[i].waitingRoomGlobalId
                                                });

                                                if (foundedElement) {
                                                    if (foundedElement.original.attributes.STAN_OBIEKTU_DOM === ObjectState.Assigned ||
                                                        foundedElement.original.attributes.STAN_OBIEKTU_DOM === ObjectState.ToBeCorrected ||
                                                        foundedElement.original.attributes.STAN_OBIEKTU_DOM === ObjectState.WaitingRoomEdition) {
                                                        foundedElement.original.attributes.STAN_OBIEKTU_DOM = ObjectState.DownloadedForEdition
                                                    }
                                                    if (foundedElement.original.attributes.STAN_OBIEKTU_DOM === ObjectState.ToBeVerified ||
                                                        foundedElement.original.attributes.STAN_OBIEKTU_DOM === ObjectState.WaitingRoomEditionVerification) {
                                                        foundedElement.original.attributes.STAN_OBIEKTU_DOM = ObjectState.DownloadedForVerification
                                                    }
                                                    elementsNew.push({
                                                        card: elements[i],
                                                        tableParams: foundedElement.original.attributes
                                                    })
                                                }
                                            }
                                            var cards: CardStateUpdate[] = [];
                                            elementsNew.forEach((element) => {
                                                cards.push({
                                                    gid: element.card.waitingRoomGlobalId,
                                                    state: element.tableParams.STAN_OBIEKTU_DOM
                                                });
                                            })
                                            if (username) {
                                                changeStatusRegistrationCardFormForDownload(cards, api.apiUrl + api.apiVersion).then((responseStatus: any) => {
                                                    if (responseStatus.success) {
                                                        setTaskListInDb(elementsNew, username).then((response) => {
                                                            setLoading(false);
                                                            refresh();
                                                            notifySuccess({ message: "Wszystkie karty zostały pobrane na komputer" });
                                                        }).catch((error) => {
                                                            notifyWarn({ message: "Niepowodzenie podczas pobrania karty na komputer" });
                                                        })
                                                    }
                                                    else {
                                                        showErrorMsg("Niepowodzenie podczas aktualizacji statusu obiektu");
                                                    }
                                                }).catch(() => {
                                                    showErrorMsg("Niepowodzenie podczas aktualizacji statusu obiektu");
                                                })
                                            }
                                            else {
                                                notifyWarn({
                                                    message: "Przeloguj się, ponieważ nie możemy pobrać nazwy użytkownika," +
                                                        " być może nie miałeś przez moment dostępu do internetu"
                                                })
                                                setLoading(false);
                                            }
                                        }
                                        else {
                                            setLoading(false);
                                        }
                                    })
                                }).catch((error) => {
                                    console.log("error", error);
                                    showErrorMsg("Niepowodzenie podczas pobrania karty na komputer");
                                    setLoading(false);
                                })
                            }
                        }).catch((error) => {
                            console.log("error", error);
                            showErrorMsg("Niepowodzenie podczas pobrania karty na komputer");
                            setLoading(false);
                        })
                    }).catch((error) => {
                        console.log("error", error);
                        showErrorMsg("Niepowodzenie podczas pobrania karty na komputer");
                        setLoading(false);
                    })
                }
                else {
                    setLoading(false);
                }
            }
        }).catch(() => {
            showErrorMsg("Niepowodzenie podczas pobrania karty na komputer");
            setLoading(false);
        });
    }

    const showErrorMsg = (message: string) => {
        notifyError({ message: message });
        setLoading(false);
        refresh();
    }

    const handleThreeDotsAssignVerifierClick = () => {
        if (checkboxesTable.length > 0) {
            var checkedRows = checkboxesTable.map(item => {
                item.original.attributes.RODZAJ_OBIEKTU_DOM = getObjectTypeCodedValue(item.original.attributes.RODZAJ_OBIEKTU);
                return item.original.attributes
            });
            setRowsForModal(checkedRows);
            setAssignEditorByVerifier(false);
            setShowEditorVerifierModal(true);
            setIsModalEditorVersion(false);
        }
    }

    const handleThreeDotsMarkStatusClick = async (status: ObjectState, objType: string) => {
        var waitingRoomGids = checkboxesTable.map(row => row.original.attributes.GLOBALID);
        if (objType === "KR") {
            markCardStatus(status, waitingRoomGids);
        } else if (objType === "PO") {
            markProtocolStatus(status, waitingRoomGids);
        }
    }

    const checkStatusesForReturnCard = (cards?: CardReturn[]) => {
        let listCard = [];
        if (cards) {
            for (let i = 0; i < cards.length; i++) {
                if (cards[i].state !== ObjectState.Accepted && cards[i].state !== ObjectState.WaitingRoomEdition &&
                    cards[i].state !== ObjectState.Complete && cards[i].state !== ObjectState.NoGeometry &&
                    cards[i].state !== ObjectState.WaitingRoomEditionVerification
                ) {
                    listCard.push(cards[i].idNumber);
                }
                if (cards[i].krType === ObjectType.POO || cards[i].krType === ObjectType.POTZ) {
                    if (cards[i].state !== ObjectState.Accepted && cards[i].state !== ObjectState.WaitingRoomEdition) {
                        listCard.push(cards[i].idNumber);
                    }
                }
            }
            if (listCard.length > 0) {
                notifyWarn({ message: `Karty o numerach:${listCard.toString()} mają niewłaściwy status do zwrotu` })
                return false;
            }
        }
        return true;
    }

    const handleThreeDotsCardsReturnClick = async () => {
        if (checkboxesTable.length > 0) {
            setLoading(true);
            let cardsReturn: CardReturn[] = [];
            let cards = checkboxesTable.map((checkboxTable) => {
                return {
                    gid: checkboxTable.original.GLOBALID,
                    state: checkboxTable.original.STAN_OBIEKTU_DOM
                };
            });
            let request: CheckEditor = {
                cards: cards
            }
            const returnCardsToServer = () => {
                return new Promise((resolve, reject) => {
                    const PromiseArray: Promise<any>[] = [];
                    if (cards && cards.length > 0) {
                        for (let j = 0; j < cards.length; j++) {
                            PromiseArray.push(getTask(cards[j].gid as string));
                        }
                    }
                    if (PromiseArray.length > 0) {
                        return Promise.all(PromiseArray).then((response) => {
                            if (response && response.length > 0) {
                                response.forEach((resp) => {
                                    const _krType = resp.elementParams.tableParams.RODZAJ_OBIEKTU;
                                    if (resp.elementParams.tableParams.STAN_OBIEKTU_DOM === ObjectState.DownloadedForEdition) {
                                        if (resp.elementParams.tableParams.ZNACZNIK_PROCESU_DOM === ProcessMarker.O) {
                                            if (_krType === ObjectType.KRO) {
                                                resp.elementParams.tableParams.STAN_OBIEKTU_DOM = ObjectState.WaitingRoomEdition;
                                            }
                                            if (_krType === ObjectType.KRTZ) {
                                                resp.elementParams.tableParams.STAN_OBIEKTU_DOM = ObjectState.WaitingRoomEdition;
                                            }
                                        } else {
                                            resp.elementParams.tableParams.STAN_OBIEKTU_DOM = ObjectState.WaitingRoomEdition;
                                        }
                                    }
                                    if (resp.elementParams.tableParams.STAN_OBIEKTU_DOM === ObjectState.DownloadedForVerification) {
                                        resp.elementParams.tableParams.STAN_OBIEKTU_DOM = ObjectState.WaitingRoomEditionVerification;
                                    }
                                    var objToSave = krToSave(resp.elementParams.card);
                                    if (_krType === ObjectType.KRO) {
                                        //extra: obsługa pobranych kart przed wgraniem poprawki
                                        setDevelopmentsRelTech(objToSave);
                                    }
                                    cardsReturn.push({
                                        krForm: JSON.stringify(objToSave),
                                        state: resp.elementParams.tableParams.STAN_OBIEKTU_DOM,
                                        krType: _krType,
                                        idNumber: resp.elementParams.tableParams.NUMER_IDENTYFIKACYJNY.toString(),
                                        status: resp.elementParams.tableParams.WALIDACJA_DOM
                                    })
                                })
                                var request: ObjectsReturn = {
                                    cards: cardsReturn
                                }
                                if (checkStatusesForReturnCard(request.cards)) {
                                    returnCards(request, api.apiUrl + api.apiVersion).then((response: any) => {
                                        let resp = response as string[];
                                        if (resp && resp.length > 0) {
                                            notifyWarn({ message: `Błędy podczas zwracania kart do poczekalni: ${resp.toString()}` })
                                            setLoading(false);
                                            setReloadTable(!reloadTable);
                                        }
                                        else {
                                            const PromiseArrayDelete: Promise<any>[] = [];
                                            for (let j = 0; j < cards.length; j++) {
                                                PromiseArrayDelete.push(deleteTask(cards[j].gid as string));
                                            }
                                            if (PromiseArrayDelete.length > 0) {
                                                return Promise.all(PromiseArrayDelete).then((response) => {
                                                    console.log("response from deleting", response);
                                                    notifySuccess({ message: "Wszystkie karty zostały zwrócone" });
                                                    setLoading(false);
                                                    setReloadTable(!reloadTable);
                                                    resolve(response);
                                                }).catch((error) => {
                                                    console.log("error from deleting localBase" + error);
                                                    notifyError({ message: "Błąd podczas usuwania kart z bazy lokalnej" });
                                                    resolve(error);
                                                })
                                            }
                                            else {
                                                setLoading(false);
                                                setReloadTable(!reloadTable);
                                                resolve(undefined);
                                            }
                                        }
                                    }).catch((error) => {
                                        console.log("error returning cards", error);
                                        var errorText = "Błąd podczas zwracania kart";
                                        if (error.response?.data?.title === "Unauthorized") {
                                            errorText = `${errorText}: Nie masz uprawnień do edycji/zwrócenia tej karty, skontaktuj się z administratorem`;
                                        }
                                        notifyWarn({ message: errorText });
                                        setLoading(false);
                                        setReloadTable(!reloadTable);
                                        resolve(error);
                                    })
                                }
                                else {
                                    setLoading(false);
                                    setReloadTable(!reloadTable);
                                    resolve(undefined);
                                }
                            }
                        });
                    }
                    else {
                        setLoading(false);
                        setReloadTable(!reloadTable);
                        resolve(undefined);
                    }
                })
            }
            checkEditorCards(request, api.apiUrl + api.apiVersion).then((response: any) => {
                if (response.length > 0) {
                    let numberIds = response as string[];
                    const PromiseArrayDelete: Promise<any>[] = [];
                    if (numberIds && numberIds.length > 0) {
                        for (let i = 0; i < numberIds.length; i++) {
                            let foundCard = checkboxesTable.find((card) => {
                                return card.original.NUMER_IDENTYFIKACYJNY.toString() === numberIds[i] || card.original.GLOBALID.toString() === numberIds[i]
                            })
                            if (foundCard) {
                                let index = cards.findIndex(x => x.gid === foundCard?.original.GLOBALID);
                                if (index !== -1) {
                                    cards.splice(index, 1);
                                    numberIds[i] = foundCard?.original.NUMER_IDENTYFIKACYJNY;
                                }
                                PromiseArrayDelete.push(deleteTask(foundCard.original.GLOBALID as string));
                            }
                        }
                        return Promise.all(PromiseArrayDelete).then((response) => {
                            notifyWarn({ message: `Karty o numerze: ${numberIds.toString()} są już przypisane do innych użytkowników lub anulowane. Karty zostały usunięte.` });
                            returnCardsToServer()?.then((response) => {
                                setCheckboxesTable([]);
                            });
                        }).catch((error) => {
                            setCheckboxesTable([]);
                            console.log("error from deleting localBase" + error);
                            setLoading(false);
                            notifyError({ message: "Błąd podczas usuwania kart z bazy lokalnej" });
                        })
                    }
                }
                else {
                    returnCardsToServer()?.then((response) => {
                        setCheckboxesTable([]);
                    });
                }
            }).catch((error: any) => {
                notifyError({ message: "Błąd poczas sprawdzania kart: " + error });
                setLoading(false);
                setCheckboxesTable([]);
            })
        }
    }

    const markProtocolStatus = async (status: ObjectState, gids: string[]) => {
        // Validate all selected POs
        let validateSelectedProtocolsProps: ValidateSelectedProtocolsProps = {
            waitingRoomGids: gids,
            apiBase: api.apiUrl + api.apiVersion
        }
        setLoading(true);
        validateSelectedProtocols(validateSelectedProtocolsProps)
            .then((response: any) => {
                if (response) {
                    let updateProtocolStateProps: UpdateProtocolStateProps = {
                        waitingRoomGids: gids,
                        state: status,
                        apiBase: api.apiUrl + api.apiVersion
                    }

                    updateProtocolState(updateProtocolStateProps)
                        .then((res: any) => {
                            setLoading(false);
                            if (res.success) {
                                notifySuccess({ message: 'Zmieniono status na "Zatwierdzona"' });
                                setCheckboxesTable([]);
                            } else if (res.info) {
                                notifyError({ message: `Niepowodzenie: '${res.info}'` });
                            } else {
                                changeStatusFailed();
                            }
                            setReloadTable(!reloadTable);
                        })
                        .catch(() => {
                            changeStatusFailed();
                        });
                } else {
                    notifyError({ message: "Wybrane formularze nie są kompletne" });
                    setLoading(false);
                }
            })
            .catch(() => {
                changeStatusFailed();
            });
    }

    const changeStatusFailed = () => {
        notifyError({ message: "Niepowodzenie podczas aktualizacji statusu obiektu" });
        setLoading(false);
    }

    const markCardStatus = async (status: ObjectState, gids: string[]) => {
        // Validate all selected KRs
        let validateSelectedProps: ValidateSelectedCardsProps = {
            waitingRoomGids: gids,
            apiBase: api.apiUrl + api.apiVersion,
            isVerifier: status === ObjectState.Accepted
        }

        setLoading(true);
        if (status === ObjectState.Accepted || status === ObjectState.Complete) {
            validateSelectedCards(validateSelectedProps, api.featureServices.additionalDictionaries["landslide"], api.featureServices.additionalDictionariesBaseUrl)
                .then((response: any) => {
                    if (response) {
                        changeCardStatuses(status, gids);
                    } else {
                        notifyError({ message: "Wybrane formularze nie są kompletne" });
                        setLoading(false);
                    }
                })
                .catch(() => {
                    changeStatusFailed();
                });
        } else {
            changeCardStatuses(status, gids);
        }
    }

    const changeCardStatuses = (status: string, gids: string[]) => {
        const isEditor = status === ObjectState.Complete;
        changeStatus(status, gids, isEditor).then((res: any) => {
            setLoading(false);
            if (res.success) {
                notifySuccess({ message: `Zmieniono status na '${status}'` });
                refresh();
                if (status === ObjectState.Accepted) {
                    setCheckboxesTable([]);
                }
            } else if (res.info) {
                notifyError({ message: `Niepowodzenie: '${res.info}'` });
            } else {
                changeStatusFailed();
            }
        }).catch(() => { changeStatusFailed(); })
    }

    const canShowAll = useCallback(() => {
        return functionsPermissions.browseAllKRPOWaitingTab.active;
    }, [functionsPermissions.browseAllKRPOWaitingTab.active]);

    const refresh = () => {
        setReloadTable(!reloadTable);
    }

    const whereBuild = (filtersTable: FiltersTable[]) => {
        var mainWhere: string = "1=1 AND (ZNACZNIK_PROCESU_DOM<>'x' OR ZNACZNIK_PROCESU_DOM IS NULL)";
        return filtersToQuery(filtersTable, mainWhere);
    }

    const getSort = () => {
        switch (sortConfigTaskList.sortType) {
            case SortType.Asc:
                return `${sortConfigTaskList.filterColumnName}`;
            case SortType.Desc:
                return `${sortConfigTaskList.filterColumnName} DESC`;
            case SortType.None:
                return 'ID DESC';
        }
    }

    const sortLocal = (rows: any[]) => {
        switch (sortConfigTaskList.sortType) {
            case SortType.Asc: {
                rows.sort((a, b) => {
                    const valueA = a[sortConfigTaskList.filterColumnName!];
                    const valueB = b[sortConfigTaskList.filterColumnName!];
                    if (typeof (valueA) === 'string') {
                        if (valueB === null) return -1;
                        return valueA.localeCompare(valueB, 'pl');
                    } else {
                        if (valueA === null && valueB === null) return 0;
                        if (valueB === null) return -1;
                        if (valueA === null) return 1;
                        return valueA - valueB;
                    }
                })
                break;
            }
            case SortType.Desc: {
                rows.sort((a, b) => {
                    const valueA = a[sortConfigTaskList.filterColumnName!];
                    const valueB = b[sortConfigTaskList.filterColumnName!];
                    if (typeof (valueA) === 'string') {
                        if (valueB === null) return 1;
                        return valueB.localeCompare(valueA, 'pl');
                    } else {
                        if (valueA === null && valueB === null) return 0;
                        if (valueB === null) return 1;
                        if (valueA === null) return -1;
                        return valueB - valueA;
                    }
                })
                break;
            }
            case SortType.None: {
                rows.sort((a, b) => {
                    return b.ID - a.ID
                })

            }
        }
    }

    const WhereLocal = (mappedLocal: any[]) => {
        return filterLocal(mappedLocal, filtersTableTaskList);
    }

    useEffect(() => {
        if (pagination.pageSize === 0) {
            return;
        }
        setLoading(true);
        var _query: any = null;
        if (selectedTab === viewTaskListTypes.TaskListWaiting) {
            var query = new Query({
                outFields: ["*"],
                start: pagination.pageIndex * pagination.pageSize,
                num: pagination.pageSize,
                returnGeometry: false,
                where: canShowAll() ? (`${whereBuild(filtersTableTaskList)}`) : getUserWhere(),
                orderByFields: [getSort()]
            })
            _query = tableFeatureService({ url: api.featureServices.taskList }, query, api.tableDefaultExcluding);
            _query.promise.then((res: any) => {
                setHeadersExtend(res.featureSet.headers);
                setTableAliases(res.featureSet.headers, "aliases");
                setFeatureSetExtend(res.featureSet.data);
                recalcPagination(res.count);
                setLoading(false);
            }).catch((err: any) => {
                if (err?.reason !== "cancel") {
                    setFeatureSetExtend([]);
                    setLoading(false);
                }
            })
        }

        if (selectedTab === viewTaskListTypes.TaskListLocal) {
            getTaskListFromDb().then((elements) => {
                recalcPagination(elements.length);
                getTableAliases("aliases").then((result) => {
                    var mappedElements = elements.map((element) => {
                        return element.elementParams.tableParams;
                    });
                    setHeadersExtend(result);
                    sortLocal(mappedElements);
                    mappedElements = WhereLocal(mappedElements);
                    mappedElements = mappedElements.slice(pagination.pageIndex * pagination.pageSize,
                        (pagination.pageIndex * pagination.pageSize) + pagination.pageSize)
                    setFeatureSetExtend(mappedElements);
                }).catch((err: any) => {
                    notifyError({ message: "Błąd podczas pobierania aliasów tabeli z lokalnej bazy." })
                    setLoading(false);
                });
            }).catch((err: any) => {
                if (err?.reason !== "cancel") {
                    setFeatureSetExtend([]);
                    setLoading(false);
                }
            }).finally(() => {
                setLoading(false);
            })
        }

        return () => {
            if (_query) {
                _query.cancel();
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedTab, api, viewTaskListTypes, user, getUserWhere, userRoles, filtersTableTaskList, reloadTable, pagination.pageIndex, pagination.pageSize, canShowAll, recalcPagination, sortConfigTaskList]);

    useEffect(() => {
        const showAll = functionsPermissions.browseAllKRPOWaitingTab.active;
        const canBeInTable = (feature: __esri.Graphic | null, user: string, showAll: boolean) => {
            if (feature === null || feature.attributes["idName"] !== "waitingRoom") {
                return false;
            }
            return showAll || feature.attributes["PRZYPISANY_UZYTKOWNIK"] === user;
        }

        setSelected([]);
        if (!canBeInTable(customMap.selected, username, showAll)) {
            setMapSelection([]);
            return;
        }

        const extraWhere = (showAll: boolean) => {
            let where = buildWhereFromMapToKr(customMap.selected);
            return showAll ? where : `${where} AND ${getUserWhere()}`;
        }

        const query = new Query({
            outFields: ["*"],
            where: extraWhere(showAll)
        })
        setLoading(true);
        let _query = queryFeatureSet({ url: api.featureServices.taskList }, query, api.tableDefaultExcluding);
        _query.promise.then((featureSet: any) => {
            setMapSelection(featureSet.data);
            setLoading(false);
        }).catch((err: any) => {
            if (err?.reason !== "cancel") {
                setLoading(false);
            }
        })
        return () => {
            _query.cancel();
        }
    }, [api.featureServices.taskList, api.tableDefaultExcluding, customMap.selected, getUserWhere, user, userRoles, functionsPermissions, username]);

    // Open assign editor/verifier modal on icon click
    const onClickEditorVerifierModal = (row: any) => {
        var objType = row.attributes.RODZAJ_OBIEKTU;
        if (objType === ObjectType.KRO || objType === ObjectType.KRTZ) {
            var selectedRows: any[] = [];
            row.attributes.RODZAJ_OBIEKTU_DOM = getObjectTypeCodedValue(objType);
            selectedRows.push(row.attributes);
            setRowsForModal(selectedRows);

            var canAssignEdit = canAssignEditor(functionsPermissions.assignEditor.active, userRoles, row.attributes.STAN_OBIEKTU_DOM, viewTaskListType === viewTaskListTypes.TaskListWaiting);
            var canAssignVerify = canAssignVerifier(functionsPermissions.assignVerifier.active, extendedUserPermissions, userRoles, objType,
                row.attributes.STAN_OBIEKTU_DOM, row.attributes.TERYT, viewTaskListType === viewTaskListTypes.TaskListWaiting, row.attributes.ZNACZNIK_PROCESU_DOM);

            if (canAssignEdit && canAssignVerify) {
                setConfirmationEditorVerifier(true);
            }
            else if (canAssignEdit || canAssignVerify) {
                setShowEditorVerifierModal(true);
                setAssignEditorByVerifier(canAssignEdit && canHaveEditorAssignedByVerifier(row.attributes.STAN_OBIEKTU_DOM));
                setIsModalEditorVersion(canAssignEdit);
            }
        }
    }

    const onCloseEditorVerifierModal = () => {
        setShowEditorVerifierModal(false);
    }

    const onChangeUserSuccess = (data: any[]) => {
        setCheckboxesTable([]);
    }

    var assignEditorVerifierModalProps: AssignEditorVerifierModalProps = {
        onClose: onCloseEditorVerifierModal,
        isEditorVersion: isModalEditorVersion,
        rows: rowsForModal,
        assignEditorByVerifier: assignEditorByVerifier,
        onSuccess: onChangeUserSuccess
    }

    // Select assign editor/verifier modal action

    const onClickChoiceModal = (assignEditor: boolean) => {
        setShowEditorVerifierModal(true);
        setConfirmationEditorVerifier(false);
        setIsModalEditorVersion(assignEditor);
        setAssignEditorByVerifier(assignEditor && canHaveEditorAssignedByVerifier(rowsForModal[0].STAN_OBIEKTU_DOM));
    }
    const onCloseChoiceModal = () => {
        setConfirmationEditorVerifier(false);
    }

    const onCloseAutomaticVerificationModal = () => {
        setAutomaticVerificationModal(false);
        setReloadTable(!reloadTable);
    }

    const getBtnPropsChoiceModal = (title: string, onClick: React.MouseEventHandler<HTMLButtonElement>): ButtonFieldProps => {
        return {
            BtnProps: {
                onClick: onClick,
                style: {
                    width: '100%',
                    height: '100%'
                },
                className: "cardItem body-txt-XL"
            },
            placeHolder: title,
            placeHolderStyle: stylizationVerticalAlign,
        };
    }

    const iconChoiceModalStyle: React.CSSProperties = {
        width: 40,
        height: 40,
    }

    var taskListLocalTabViewProps: TaskListLocalTabViewProps = {
        headers: headersExtend,
        data: featureSetExtend,
        columnConfig: columnConfig.current,
        selection: selected,
        extraSelection: mapSelection,
        loading: loading,
        isPagination: true,
        allCount: allCount,
        pagination: pagination,
        setPagination: setPagination,
        pageCount: pageCount,
        setPageCount: setPageCount,
        onPaginationChange: onPaginationChange,
        onTrClick: functionsPermissions.pointObjOnMap.active ? handleTrClick : undefined,
        threeDotsProps: {
            editOnClick: handleThreeDotsEditClick,
            collectiveEditOnClick: handleThreeDotsCollectiveEditClick, //Akcja edycji zbiorczej
            validateOnClick: handleThreeDotsValidateClick,
            table: ThreeDotsTableTypes.TaskListLocal,
            markStatus: handleThreeDotsMarkStatusClick,
            automaticVerificationClick: handleThreeDotsAutomaticVerificationClick,
            ReturnCardClick: handleThreeDotsCardsReturnClick
        },
        handlePersonAddClick: onClickEditorVerifierModal
    }

    var taskListWaitingTabViewProps: TaskListWaitingTabViewProps = {
        headers: headersExtend,
        data: featureSetExtend,
        columnConfig: columnConfig.current,
        selection: selected,
        extraSelection: mapSelection,
        loading: loading,
        isPagination: true,
        allCount: allCount,
        pagination: pagination,
        setPagination: setPagination,
        pageCount: pageCount,
        setPageCount: setPageCount,
        onPaginationChange: onPaginationChange,
        onTrClick: functionsPermissions.pointObjOnMap.active ? handleTrClick : undefined,
        threeDotsProps: {
            editOnClick: handleThreeDotsEditClick,
            collectiveEditOnClick: handleThreeDotsCollectiveEditClick,
            validateOnClick: handleThreeDotsValidateClick,
            cancelOAndKOnClick: handleThreeDotsCancelOAndKClick,
            cancelAAndNClick: handleThreeDotsCancelAAndNClick,
            table: ThreeDotsTableTypes.TaskListWaiting,
            markStatus: handleThreeDotsMarkStatusClick,
            assignEditorOnClick: handleThreeDotsAssignEditorClick,
            assignVerifierOnClick: handleThreeDotsAssignVerifierClick,
            automaticVerificationClick: handleThreeDotsAutomaticVerificationClick,
            downloadCardClick: handleThreeDotsDownloadCardClick
        },
        handlePersonAddClick: onClickEditorVerifierModal,
        setAdminDecisionRow: setAdminDecisionRow
    }

    const renderView = (viewType: number) => {
        var isWaitingRoomTab = functionsPermissions.browseUserKRPOWaitingTab.active || functionsPermissions.browseAllKRPOWaitingTab.active;
        var isLocalTab = functionsPermissions.browseKRPOInLocalBase.active;

        if (pagination.pageSize === 0) {
            return null;
        }

        switch (viewType) {
            case viewTaskListTypes.TaskListLocal:
                return isLocalTab ? <TaskListLocalTabView {...taskListLocalTabViewProps} /> : null;
            case viewTaskListTypes.TaskListWaiting:
                return isWaitingRoomTab ? <TaskListWaitingTabView {...taskListWaitingTabViewProps} /> : null;
        }
    }

    var getTabOptions = () => {
        var options: TabbarOption[] = [];
        var isWaitingRoomTab = functionsPermissions.browseUserKRPOWaitingTab.active || functionsPermissions.browseAllKRPOWaitingTab.active;
        if (isWaitingRoomTab) options.push({ name: 'Poczekalnia', additionalIcon: hourglass, onClick: (e) => { onClickOption(viewTaskListTypes.TaskListWaiting, e) } });
        if (functionsPermissions.browseKRPOInLocalBase.active) options.push({ name: 'Komputer osobisty', additionalIcon: computer, onClick: (e) => { onClickOption(viewTaskListTypes.TaskListLocal, e) } });
        return options;
    }

    var OptionsOnlyLocal: TabbarOption[] = [
        { name: 'Komputer osobisty', additionalIcon: computer, onClick: (e) => { onClickOption(viewTaskListTypes.TaskListLocal, e) } }
    ]

    return (
        <>
            <div className="taskListView">
                <Tabbar selected={selectedTab} options={onlineMode ? getTabOptions() : OptionsOnlyLocal} onlineMode={onlineMode}></Tabbar>{renderView(selectedTab)}
            </div>
            {showEditorVerifierModal && <AssignEditorVerifierModal {...assignEditorVerifierModalProps} />}
            {confirmationEditorVerifier &&
                <Modal
                    title={"Wybierz akcję"}
                    titleIcon={personAdd}
                    iconStyle={iconChoiceModalStyle}
                    width={'500px'}
                    height={'200px'}
                    onClose={onCloseChoiceModal}>
                    <div className="confirmationEditorVerifierBtns">
                        <ButtonField {...getBtnPropsChoiceModal("Przypisz Edytora", () => { onClickChoiceModal(true) })}></ButtonField>
                        <ButtonField {...getBtnPropsChoiceModal("Przypisz Weryfikatora", () => { onClickChoiceModal(false) })}></ButtonField>
                    </div>
                </Modal>
            }
            {cancelType !== null && <CancelTaskWindow type={cancelType} rows={adminDecisionRow !== undefined ? [adminDecisionRow] : checkboxesTable}
                onClose={setCancelClose} reload={refresh} />}
            {automaticVerificationModal &&
                <Modal
                    title={"Walidacja"}
                    width="90vw"
                    height="90vh"
                    onClose={onCloseAutomaticVerificationModal}
                    bodyClassName="modalBodyAutoVerification"
                >
                    <AutomaticVerificationModal cards={automaticVerificationCards} rows={checkboxesTable} triggeredFromLocal={selectedTab === viewTaskListTypes.TaskListLocal} />
                </Modal>
            }
        </>
    );
}

export default TaskListView;
